<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/services">Services</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Integration and Implementation
              </li>
            </ol>
          </nav>
          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">Integration and Implementation</h2>
              <p class="lead">
                The number of various solutions implemented at customers'
                facilities is rather large today. Often the subsystems of
                seemingly unified IT landscape are either loosely connected or
                the interaction between them is ensured by file and data
                transfer via e-mail or from hand to hand. Following a particular
                trend, Universal Tech vendors provide the customer with final and
                universalized solutions. Such subsystem units solve a certain
                task and form separate IT centers which also require mutual
                infrastructural integration. Strange as it may seem, this is
                even more difficult task as far as the ready-made solution will
                not allow deep intrusion and access to required information or
                management subsystems.
              </p>
              <p class="lead">
                Nevertheless, unification and joining of information flows can
                significantly simplify business processes and lead to the growth
                of interaction efficiency both inside the company and externally
                (with clients and partners).
              </p>

              <p class="lead">
                The very integration task is important for the business as far
                as represents a new level of quality services. This is
                especially important for companies where IT is the right tool to
                achieve business objectives. But it is also important to provide
                optimum integration given minimization of expenses for the
                purchase of hardware and software and maintenance of the former
                IT investments.
              </p>

              <p class="lead">
                We offer services on integration and implementation of
                infrastructure applying approach allowing minimization of costs
                for the solution implementation.<br />
                It is based on:
              </p>

              <ul class="lead">
                <li>
                  Optimization of the solution totalcost; calculation,
                  analysis and detectionof ways to reduce total cost of
                  ownership (TCO);
                </li>
                <li>
                  Proposals on the current IT resources upgrade; development
                  of migration plan taking into account business peculiarities
                  (reduction of downtime, detection of narrow performance
                  points, transfer of non-core systems to outsourcing, including
                  data-center).
                </li>
              </ul>

              <p class="lead">
                Highly qualified team of our specialists will ensure
                methodologically correct implementation process, timely solution
                of non-standard tasks which can occur during the project. The
                project success is guaranteed by the application of the best
                integration practices, and valid integration approaches
                accumulated during the long time of our work at the IT market.
              </p>
            </div>

            <div class="col-lg-4">
              <ServicesSideNav></ServicesSideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import ServicesSideNav from "./ServicesSideNav";
export default {
  name: "cloud overview",
  components: {
    ServicesSideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
